export default [
  {
    path: '/student-invoices',
    name: 'student-invoice',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-invoice/index.vue')
  }
]
